import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate, useLocation } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMenu, FiX } = FiIcons;

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleScrollToSection = (e, id) => {
    e.preventDefault();
    setMobileMenuOpen(false); // Close mobile menu if open
    
    if (location.pathname !== '/') {
      navigate('/');
      // Wait for navigation and rendering before scrolling
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-neutral-surface/90 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-5'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center">
          
          {/* Logo */}
          <div className="flex items-center gap-2.5 cursor-pointer" onClick={() => navigate('/')}>
            <img 
              src="https://media-manager-c.questera.ai/greta-media/64b6f00450a2ccd8585f32418c01e01155b9a46657aed859be5d908803e7074989df043f4ede815d2dc0fa021038408b/images/aW1hZ2UvcG5n/9cfb9a87f42be2968b832fdb29a8d339.png" 
              alt="Logo" 
              className="w-10 h-10 rounded-xl object-cover shadow-soft flex-shrink-0"
            />
            <span className="text-base font-bold text-text-primary tracking-tight leading-tight">
              Pickleball<br />
              <span className="text-primary">Insight Coach</span>
            </span>
          </div>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8">
            <button onClick={(e) => handleScrollToSection(e, 'features')} className="text-text-secondary hover:text-primary transition-colors font-medium">Features</button>
            <button onClick={(e) => handleScrollToSection(e, 'how-it-works')} className="text-text-secondary hover:text-primary transition-colors font-medium">How it Works</button>
            <button onClick={(e) => handleScrollToSection(e, 'testimonials')} className="text-text-secondary hover:text-primary transition-colors font-medium">Reviews</button>
            <button onClick={(e) => handleScrollToSection(e, 'download')} className="bg-primary hover:bg-primary-dark text-white px-6 py-2.5 rounded-full font-medium transition-all shadow-md hover:shadow-lg transform hover:-translate-y-0.5">
              Download Free
            </button>
          </div>

          {/* Mobile Menu Toggle */}
          <button 
            className="md:hidden text-text-primary p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <SafeIcon icon={mobileMenuOpen ? FiX : FiMenu} className="text-2xl" />
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {mobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden bg-neutral-surface border-b border-neutral-border overflow-hidden"
          >
            <div className="px-4 pt-2 pb-6 space-y-4 flex flex-col">
              <button onClick={(e) => handleScrollToSection(e, 'features')} className="text-left px-3 py-2 text-text-secondary hover:text-primary hover:bg-neutral-bg rounded-lg font-medium">Features</button>
              <button onClick={(e) => handleScrollToSection(e, 'how-it-works')} className="text-left px-3 py-2 text-text-secondary hover:text-primary hover:bg-neutral-bg rounded-lg font-medium">How it Works</button>
              <button onClick={(e) => handleScrollToSection(e, 'download')} className="bg-primary text-white text-center px-4 py-3 rounded-xl font-medium mt-4 shadow-md">
                Download Free
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;